const defaultState = {}

const appendedTemplates = (state, params) => {
  return [ params, ...state.templates ]
}

const updatedEvents = (state, params) => {
  const index = state.templates.findIndex((template) => { return template.id == params.id })
  let updatedTemplate = { ...state.templates[index], ...params }
  return [
    ...state.templates.slice(0, index), 
    updatedTemplate,
    ...state.templates.slice(index + 1, state.templates.length)
  ]
}

const releasedTemplates = (state, id) => {
  const templateIndex = state.templates.findIndex((template) => { return template.id == id })
  return [
    ...state.templates.slice(0, templateIndex), 
    ...state.templates.slice(templateIndex + 1, state.templates.length)
  ]
}

const messageTemplates = (state = defaultState, {type, payload}) => {
  switch (type) {
    case 'MESSAGE_TEMPLATES.INIT':
      return {...state, ...payload}
    case 'MESSAGE_TEMPLATES.ADD':
      return {...state, templates: appendedTemplates(state, payload)}
    case 'MESSAGE_TEMPLATES.UPDATE':
      return {...state, templates: updatedEvents(state, payload)}
    case 'MESSAGE_TEMPLATES.DELETE':
      return {...state, templates: releasedTemplates(state, payload)}
    default:
      return state
  }
}

export default messageTemplates
